import { HttpClient } from "@angular/common/http";
import { Injectable } from "@angular/core";
import { Navigation } from "app/core/navigation/navigation.types";
import { Observable, ReplaySubject, tap } from "rxjs";

@Injectable({
  providedIn: "root",
})
export class NavigationService {
  private _navigation: ReplaySubject<Navigation> =
    new ReplaySubject<Navigation>(1);

  constructor(private _httpClient: HttpClient) {}

  //================================================
  //? @GETTERS
  //================================================

  get navigation$(): Observable<Navigation> {
    return this._navigation.asObservable();
  }

  //================================================
  //? @PUBLIC METHODS
  //================================================

  /**
   * Get all navigation data
   */
  get(): Observable<Navigation> {
    return this._httpClient.get<Navigation>("api/common/navigation").pipe(
      tap((navigation) => {
        this._navigation.next(navigation);
      }),
    );
  }
}
